import type { VoidFunctionComponent } from 'react';
import Icon, { icons } from '../Icon';

import styles from './PaidPill.module.less';

type PaidPillProps = {
  iconOnly?: boolean;
};

const PaidPill: VoidFunctionComponent<PaidPillProps> = ({ iconOnly }) => {
  return (
    <div className={iconOnly ? styles.paidPillIconOnly : styles.paidPill} data-testid="paid-pill">
      <Icon icon={icons.lockOutline} />
      {iconOnly ? '' : ' Paid'}
    </div>
  );
};

export default PaidPill;
